import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const colorMap: Record<string, string> = {
  primary: "hover:border-primary-300",
  accent: "hover:border-accent-300",
  secondary: "hover:border-secondary-300",
};

const iconMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-900",
};

export default function CategoryGrid() {
  return (
    <section className="container-page mt-10 md:mt-14">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">挑一部喜欢的开始看</h2>
          <p className="mt-1.5 text-sm text-foreground-600">四大频道，总有一部能治愈你</p>
        </div>
        <Link to="/category/all" className="hidden items-center gap-1 text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex">
          全部作品 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className={`group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all duration-200 hover:-translate-y-1 ${colorMap[c.color]}`}
          >
            <div className="relative h-36 w-full overflow-hidden md:h-40">
              <img
                src={c.image}
                alt={`${c.name} - ${c.subtitle}`}
                title={`${c.name}萌系漫画合集 - 喵趣漫画网`}
                className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <div className="flex items-center justify-between">
                <h3 className="text-base font-bold text-foreground-950">{c.name}</h3>
                <span className={`flex h-8 w-8 items-center justify-center rounded-full text-lg ${iconMap[c.color]}`}>
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
              <p className="mt-1 text-xs text-foreground-500">{c.subtitle}</p>
              <p className="mt-2 line-clamp-2 text-xs leading-5 text-foreground-600 md:text-sm">{c.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}